export default __webpack_public_path__ + "static/media/pictogramMarketplace40.4cb98ccd.svg";